/* eslint-disable react/jsx-one-expression-per-line */
import { first, values } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  AppBar,
  Button,
  DialogContent,
  FormControl,
  Modal,
  Paper,
  TextField,
  Tabs,
  Tab,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import styles from './Deliveries.module.css';
import modalStyles from '../ReusableComponents/ReusableComponents.module.css';
import BookingTypes from '../../Lib/Constants/booking-types';
import {
  openOrdersExport,
  warehouseDeliveriesExport,
} from '../../Lib/Utils/Table/table-export';
import LocationSelector from './LocationSelector';
import LoadingText from '../ReusableComponents/LoadingText/LoadingText';

const useStyles = makeStyles()(() => ({
  formControl: {
    margin: '20px 0px',
  },
  button: {
    marginTop: '20px',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const defaultStartDate = () => moment().startOf('day').format('YYYY-MM-DD');

const tabs = {
  WAREHOUSE: 'Warehouse',
  OPEN_REPORT: 'Late Orders Report',
};

export default function ExportDeliveriesModal(props) {
  const { classes } = useStyles();
  const { onClose, locations, defaultDate } = props;
  const [tab, setTab] = useState(tabs.WAREHOUSE);
  const [location, setLocations] = useState(first(values(locations)));
  const [loadingOpenOrders, setLoadingOpenOrders] = useState(false);

  // Warehouse State
  const [date, setDate] = useState(defaultDate);

  const [error, setError] = useState('');

  const onCloseModal = () => {
    onClose();
  };

  const downloadWarehouseDeliveries = () => {
    const options = {
      date: moment(date).toDate().toISOString(),
      type: BookingTypes.ORDER_DELIVERY,
      location_id: location.id,
    };

    warehouseDeliveriesExport(options);
  };

  const downloadOpenOrdersExport = () => {
    setLoadingOpenOrders(true);

    openOrdersExport()
      .then(() => {
        setLoadingOpenOrders(false);
      })
      .catch(console.log);
  };

  return (
    <Modal open onClose={onCloseModal}>
      <DialogContent className={modalStyles.modalContainer}>
        <Paper className={styles.exportModalContainer}>
          <AppBar position="relative">
            <Tabs
              value={tab}
              onChange={(e, val) => {
                setTab(val);
                setError('');
              }}
              aria-label="export tabs"
            >
              <Tab value={tabs.WAREHOUSE} label={tabs.WAREHOUSE} />
              <Tab value={tabs.OPEN_REPORT} label={tabs.OPEN_REPORT} />
            </Tabs>
          </AppBar>

          {tab === tabs.WAREHOUSE && (
            <div className={styles.exportContainer}>
              <div>
                <LocationSelector
                  selectedLocation={location}
                  onChange={(location_id) =>
                    setLocations(locations[location_id])
                  }
                  locations={locations}
                />
              </div>

              <FormControl
                variant="standard"
                className={classes.formControl}
                fullWidth
              >
                <TextField
                  variant="standard"
                  label="Date"
                  id="export-deliveries-date"
                  type="date"
                  value={date}
                  onChange={(e) => {
                    if (!e.target.value) {
                      setDate(defaultDate);
                    } else {
                      setDate(e.target.value);
                    }
                  }}
                />
              </FormControl>

              <div className={classes.buttonGroup}>
                <Button
                  className={classes.button}
                  onClick={downloadWarehouseDeliveries}
                  variant="outlined"
                  color="primary"
                >
                  Download
                </Button>
                <Button
                  className={classes.button}
                  onClick={onCloseModal}
                  variant="outlined"
                >
                  Close
                </Button>
              </div>
            </div>
          )}

          {tab === tabs.OPEN_REPORT && (
            <div className={styles.exportContainer}>
              <div className={styles.error}>{error}</div>
              <Button
                className={classes.button}
                onClick={downloadOpenOrdersExport}
                variant="outlined"
                color="primary"
                disabled={loadingOpenOrders}
              >
                {loadingOpenOrders ? (
                  <LoadingText text="Downloading" />
                ) : (
                  'Download Late Orders Report'
                )}
              </Button>

              <Button
                className={classes.button}
                onClick={onCloseModal}
                variant="outlined"
              >
                Close
              </Button>
            </div>
          )}
        </Paper>
      </DialogContent>
    </Modal>
  );
}

ExportDeliveriesModal.propTypes = {
  defaultDate: PropTypes.string,
  locations: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
};

ExportDeliveriesModal.defaultProps = {
  defaultDate: defaultStartDate(),
};
